// src/components/ui/TruncateLargeFileBanner.jsx — v9.5.1
// Props: rowsDetected, maxRows, onTruncate, onCancel

const MONO = "var(--font-mono)";
const BTN_PRI = {
  display: "inline-flex", alignItems: "center", gap: 6,
  padding: "9px 20px", borderRadius: "var(--radius-sm)", cursor: "pointer",
  fontFamily: MONO, fontSize: 12, fontWeight: 700, border: "none",
  background: "var(--accent-primary)", color: "#fff",
};
const BTN_GHOST = {
  ...BTN_PRI, background: "transparent",
  color: "var(--text-muted)", border: "1px solid var(--border-subtle)", fontWeight: 400,
};

export default function TruncateLargeFileBanner({ rowsDetected, maxRows, onTruncate, onCancel }) {
  return (
    <div style={{
      padding: "16px 20px", borderRadius: "var(--radius)",
      background: "var(--warning-bg)", border: "1px solid var(--warning-border)",
    }}>
      <div style={{ fontFamily: MONO, fontSize: 12, fontWeight: 700, color: "var(--warning)", marginBottom: 6 }}>
        File is too large for instant analysis
      </div>
      <div style={{ fontFamily: MONO, fontSize: 11, color: "var(--text-secondary)", lineHeight: 1.65, marginBottom: 14 }}>
        Your file has {rowsDetected?.toLocaleString("en-US")} rows.
        Analysis supports up to {maxRows?.toLocaleString("en-US")} rows.
        You can analyze the first {maxRows?.toLocaleString("en-US")} rows now.
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <button style={BTN_PRI} onClick={onTruncate}>
          Analyze first {maxRows?.toLocaleString("en-US")} rows →
        </button>
        <button style={BTN_GHOST} onClick={onCancel}>
          Upload a different file
        </button>
      </div>
    </div>
  );
}
